


















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class Refreshable extends Vue {
    @Prop() refreshing?: boolean;
}

